import { Injectable } from '@angular/core';
import { FeedbackContainerComponent } from '../containers/feedback-container/feedback-container.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

import { IFeedback } from '../interfaces/IFeedback.interface';

const DEFAULT_DELAY_SECCONDS = 60 * 60 * 3;

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {
  private openDialog!: MatDialogRef<FeedbackContainerComponent>;
  private timer: number | null = null;

  constructor(private _dialog: MatDialog) {}

  openFeedbackForm() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    this.openDialog = this._dialog.open(FeedbackContainerComponent, {
      disableClose: true,
    });
    this.openDialog.componentInstance.dialogRef = this.openDialog;
  }

  scheduleAskFeedback(delayInSecconds: number = DEFAULT_DELAY_SECCONDS) {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => {
      this.openFeedbackForm();
      this.timer = null;
    }, delayInSecconds * 1000);
  }
}
